import type {AxiosInstance} from "axios";
import {listEndpoint, type ListEndpoint} from "./util/ListEndpoint.ts";
import {metlProjectApi, type MetlProjectApi} from "./MetlProjectApi.ts";
import type {MetlApi} from "./MetlApiBase.ts";
import type {MetlGroupDebug} from "../metl-models/debug/MetlGroupDebug.ts";
import {type MetlApiQueryApi, metlApiQueryEndpoint} from "./MetlApiQueryApi.tsx";
import type { MetlPasswordExport } from "../metl-models/exports/MetlPasswordExport.ts";

export interface MetlGroupApi extends MetlApi {
    projects: ListEndpoint<MetlProjectApi>
    passwords: ListEndpoint<MetlApiQueryApi, MetlPasswordExport>
    debug: () => Promise<MetlGroupDebug>
}

export function metlGroupApi(axios: AxiosInstance, baseUrl: string, id: string): MetlGroupApi {
    return {
        id: baseUrl,
        projects: listEndpoint(axios, `${baseUrl}/projects`, `${id}/projects`,  metlProjectApi),
        passwords: listEndpoint(axios, `${baseUrl}/password`, `${id}/password`, metlApiQueryEndpoint),
        debug: () => axios.get<MetlGroupDebug>(`${baseUrl}/debug`).then(r => r.data)
    }
}